import React from 'react';
import { Icon } from './Icon.js';
export const IconImageMountain2Fill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("circle", { cx: "5", cy: "4.5", r: "2.25", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("path", { d: "M16.168,13.723l-2.152-6.815c-.173-.549-.604-.977-1.155-1.146-.549-.167-1.147-.056-1.6,.301L2.651,12.878c-.592,.469-.814,1.233-.566,1.947,.248,.714,.897,1.175,1.653,1.175H14.499c.563,0,1.078-.261,1.411-.715,.334-.455,.428-1.024,.258-1.562Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconImageMountain2Fill18.js.map